import { z } from 'zod'

import { t } from '../../../locale/utils'

export const FRENCH_SSN_SCHEMA = z
  .string({
    message: t('errors.social.security.number.invalid')
  })
  .regex(
    /^(1|2)\d{2}(0[1-9]|1[0-2])(2[AB]|[0-9]{2})\d{3}\d{3}\d{2}$/,
    t('errors.social.security.number.invalid')
  )
  .refine(
    (ssn) => {
      try {
        const num = ssn.slice(0, -2) // Exclude the last 2 check digits
        const key = parseInt(ssn.slice(-2), 10) // Get the check digits

        // Corsica departments count as numbers in the modulo calculation: 2A as 19, 2B as 18
        const numericSsn = num.replace('2A', '19').replace('2B', '18')

        // Convert to BigInt and perform the modulo operation
        const numberToValidate = BigInt(numericSsn)
        return key === 97 - Number(numberToValidate % 97n)
      } catch {
        // Return false if parsing or calculation fails
        return false
      }
    },
    {
      message: t('errors.social.security.number.invalid')
    }
  )
